import { useState } from "react";
import { motion } from "framer-motion";
import { ShoppingCart, Images } from "lucide-react";
import { toast } from "sonner";
import { useShop } from "@/shop/ShopContext";
import ProductModal from "@/components/ProductModal";

const ProductCard = ({ product, index = 0 }) => {
  const { addToCart } = useShop();
  const [open, setOpen] = useState(false);
  const photoCount = product.images?.length || 1;

  return (
    <>
      <motion.article
        data-testid="product-card"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.5, delay: (index % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
        onClick={() => setOpen(true)}
        className="group relative flex cursor-pointer flex-col overflow-hidden rounded-xl border border-white/10 bg-[#14171D] transition-colors duration-300 hover:border-[#FF5500]/60"
      >
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#14171D] via-transparent to-transparent" />
          <span className="absolute left-3 top-3 rounded border border-[#FF5500]/30 bg-black/70 px-2 py-0.5 font-mono text-[11px] text-[#FF5500]">
            {product.code}
          </span>
          {photoCount > 1 && (
            <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-black/70 px-2.5 py-1 text-[11px] text-neutral-200" data-testid="photo-count-badge">
              <Images className="h-3 w-3 text-[#FF5500]" /> {photoCount} foto
            </span>
          )}
        </div>
        <div className="flex flex-1 flex-col p-4">
          <h3 className="font-display text-lg font-medium uppercase leading-snug tracking-wide text-neutral-100">
            {product.name}
          </h3>
          <p className="mt-1 text-xs leading-relaxed text-neutral-400">{product.vehicles.join(" · ")}</p>
          <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-3">
            <span className="font-display text-2xl text-neutral-50" data-testid={`price-${product.id}`}>
              € {product.price.toFixed(2)}
            </span>
            <button
              data-testid="add-to-cart-btn"
              onClick={(e) => {
                e.stopPropagation();
                addToCart(product);
                toast.success("Aggiunto al carrello", { description: product.name });
              }}
              className="flex items-center gap-2 rounded-full bg-[#FF5500] px-4 py-2 font-display text-xs uppercase tracking-[0.15em] text-white transition-all hover:bg-[#E64D00] active:scale-95"
            >
              <ShoppingCart className="h-3.5 w-3.5" />
              Aggiungi
            </button>
          </div>
        </div>
      </motion.article>
      <ProductModal product={product} open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ProductCard;
